var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 0C7.8505 0 0 7.8505 0 17.5C0 27.1495 7.8505 35 17.5 35C27.1495 35 35 27.1495 35 17.5C35 7.8505 27.1495 0 17.5 0ZM17.5 31.8182C9.60485 31.8182 3.18182 25.395 3.18182 17.5C3.18182 9.60495 9.60485 3.18182 17.5 3.18182C25.3952 3.18182 31.8182 9.60495 31.8182 17.5C31.8182 25.395 25.395 31.8182 17.5 31.8182Z",
    fill: "#03C302"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0624 11.3121L15.0627 20.3117L10.938 16.1869C10.3168 15.5657 9.30945 15.5656 8.68815 16.1868C8.06684 16.8081 8.06684 17.8153 8.68815 18.4366L13.9377 23.6864C14.2361 23.9848 14.6407 24.1524 15.0626 24.1524C15.0627 24.1524 15.0626 24.1524 15.0627 24.1524C15.4846 24.1524 15.8892 23.9848 16.1876 23.6865L26.3122 13.5621C26.9335 12.9408 26.9335 11.9335 26.3122 11.3122C25.6909 10.6909 24.6837 10.6908 24.0624 11.3121Z",
    fill: "#03C302"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckGreen);
export default __webpack_public_path__ + "static/media/check-green.2a8ad20752d2424b4974df7bcd089e02.svg";
export { ForwardRef as ReactComponent };